import { LoginOutlined } from '@ant-design/icons';
import { Button, Card, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { ssoLoginUrl } from '../config';

export function LoginPage(): JSX.Element {
  const { t } = useTranslation();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? '/';

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#f0f2f5',
      }}
    >
      <Card style={{ width: 400, textAlign: 'center' }}>
        <Typography.Title level={3}>{t('appName')}</Typography.Title>
        <Typography.Paragraph type="secondary">{t('login.hint')}</Typography.Paragraph>
        <Button
          type="primary"
          size="large"
          icon={<LoginOutlined />}
          block
          onClick={() => {
            window.location.href = ssoLoginUrl(from);
          }}
        >
          {t('login.ssoButton')}
        </Button>
      </Card>
    </div>
  );
}
